import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appSliderActions]',
})
export class SliderActionsDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
